//import Libraries
import React from 'react';
import { connect } from 'react-redux';

//import Components
import Layout from '../../hoc/Layout/Layout'
import ScrollSection from './ScrollSection/ScrollSection.js';
import Introduction from './Introduction/Introduction';
import GreenHouse from './GreenHouse/GreenHouse';
import Company from './Company/Company';
import TitleSection from '../../components/TitleSection/TitleSection';
import Language from '../../language/language.json'

//import Style classes

const home = (props) => {
    return (
        <Layout isStore={false}>
            <ScrollSection universal={props.universal}/>
            <div style={{height: 50}}></div>
            <TitleSection 
                data={Language.titles.Introduction} 
                lang={props.universal.language}
                content={true}/>
            <Introduction universal={props.universal}/>
            <TitleSection 
                data={Language.titles.GreenHouse} 
                lang={props.universal.language}/>
            <GreenHouse universal={props.universal}/>
            <TitleSection 
                data={Language.titles.Company} 
                lang={props.universal.language}/>
            <Company universal={props.universal}/>
        </Layout>
    )
}


const mapStateToProps = (state) => {
    return { 
        universal: state.universal 
    };
}


export default connect(mapStateToProps, null)(home);



// WEBPACK FOOTER //
// ./src/pages/Home/Home.js